import React, { useEffect } from 'react';
import sessionStore from 'services/session_store';
import isEmpty from 'lodash/isEmpty';

const WithParamsToken = ({ children }) => {
  const urlParams = new URLSearchParams(window.location.search);
  const requestUserToken = urlParams.get('rut');
  const temporaryUserToken = urlParams.get('tut');
  useEffect(() => {
    !isEmpty(requestUserToken) && sessionStore.set('rut', requestUserToken);
    !isEmpty(temporaryUserToken) && sessionStore.set('tut', temporaryUserToken);
  }, []);
  return children;
};

export default WithParamsToken;
